import { Component, Input } from '@angular/core';
import { InvoiceStateColor } from '../../../../../services/invoices/invoice-states.config';

@Component({
  selector: 'app-progress-state-informer',
  templateUrl: './progress-state-informer.component.html',
  styleUrls: ['./progress-state-informer.component.scss'],
})
export class ProgressStateInformerComponent {
  protected readonly classPrefix = 'progress-state-informer';
  informerColorClass!: string;

  @Input() icon: string = '';

  @Input() text: string = '';

  @Input() informerDate: string = '';

  @Input() set color(color: InvoiceStateColor) {
    this.informerColorClass = `${this.classPrefix}-${color}`;
  }
}
